import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon';

export default function LORMatchups({ api, status }) {
  const [week, setWeek] = useState(1);
  const [matchups, setMatchups] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentWeek = status?.current_week || 1;
  const isPreSeason = status?.status === 'pre_draft' || status?.status === 'drafting';

  useEffect(() => {
    setWeek(currentWeek);
  }, [currentWeek]);

  useEffect(() => {
    setLoading(true);
    fetch(`${api}/api/lor/matchups/${week}`)
      .then(r => r.json())
      .then(data => { setMatchups(data || []); setLoading(false); })
      .catch(() => { setMatchups([]); setLoading(false); });
  }, [api, week]);

  // Group into pairs by matchup_id
  const pairs = [];
  const seen = new Set();
  for (const m of matchups) {
    if (!m.matchup_id || seen.has(m.matchup_id)) continue;
    const opp = matchups.find(x => x.matchup_id === m.matchup_id && x.roster_id !== m.roster_id);
    pairs.push({ home: m, away: opp || null });
    seen.add(m.matchup_id);
  }

  return (
    <div>
      <div className="lor-page-header">
        <h2 className="lor-page-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon emoji="⚔️" size={18} /> Matchups</h2>
        <div className="lor-matchup-week-nav">
          {Array.from({ length: 17 }, (_, i) => i + 1).map(w => (
            <button
              key={w}
              className={`lor-week-btn${week === w ? ' active' : ''}`}
              onClick={() => setWeek(w)}
            >
              {w}
            </button>
          ))}
        </div>
      </div>

      {isPreSeason ? (
        <div className="lor-preseason-banner">
          <Icon emoji="⚡" size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} /> The 2026 season has not started. Matchups will appear once the season begins.
        </div>
      ) : loading ? (
        <div className="lor-loading">Loading week {week} matchups...</div>
      ) : pairs.length === 0 ? (
        <div className="lor-empty">No matchup data for week {week}.</div>
      ) : (
        <div className="lor-matchup-grid">
          {pairs.map(({ home, away }, i) => (
            <div key={i} className="lor-card lor-matchup-card">
              <div className="lor-matchup-side">
                {home.avatar && (
                  <img
                    src={`https://sleepercdn.com/avatars/thumbs/${home.avatar}`}
                    alt={home.display_name}
                    className="lor-avatar lor-avatar--lg"
                  />
                )}
                <div className="lor-matchup-manager">{home.display_name}</div>
                <div className="lor-matchup-team">{home.team_name || ''}</div>
                <div className={`lor-matchup-score ${!away || (home.points || 0) > (away.points || 0) ? 'lor-score--winning' : ''}`}>
                  {(home.points || 0).toFixed(2)}
                </div>
              </div>

              <div className="lor-matchup-vs">VS</div>

              <div className="lor-matchup-side lor-matchup-side--away">
                {away ? (
                  <>
                    {away.avatar && (
                      <img
                        src={`https://sleepercdn.com/avatars/thumbs/${away.avatar}`}
                        alt={away.display_name}
                        className="lor-avatar lor-avatar--lg"
                      />
                    )}
                    <div className="lor-matchup-manager">{away.display_name}</div>
                    <div className="lor-matchup-team">{away.team_name || ''}</div>
                    <div className={`lor-matchup-score ${(away.points || 0) > (home.points || 0) ? 'lor-score--winning' : ''}`}>
                      {(away.points || 0).toFixed(2)}
                    </div>
                  </>
                ) : (
                  <div className="lor-matchup-bye">BYE</div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
